export const BUSINESS_ENTITY_TYPE_OPTIONS = [
  { key: 'personal', value: 'personal', text: 'Personal' },
  { key: 'corporate', value: 'corporate', text: 'Corporate' },
];

export const BUSINESS_ENTITY_TYPE_LABELS = BUSINESS_ENTITY_TYPE_OPTIONS.reduce(
  (labels, option) => ({ ...labels, [option.value]: option.text }),
  {}
);
